import React, { useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Button from '../../components/Button';
import TextInput from '../../components/TextInput';
import ContactSelect from '../../components/ContactSelect';
import Form from '../../components/Form';
import { ConnectorReferralOption } from '../../types/types';
import { StyledText } from '../../components/StyledText';

const validationSchema = Yup.object().shape({
  referralMessage: Yup.string().required().trim(),
  selectedInvestors: Yup.array().of(Yup.object().shape({
    contactName: Yup.string(),
    companyName: Yup.string(),
    email: Yup.string(),
    matched: Yup.boolean(),
    profileImage: Yup.string().nullable(),
    investorProfileId: Yup.number()
  })).required(),
  additionalEmails: Yup.array().of(Yup.string())
});

const preselectValidationSchema = Yup.object().shape({
  referralMessage: Yup.string().required(),
  selectedInvestors: Yup.array().of(Yup.object().shape({
    contactName: Yup.string(),
    companyName: Yup.string(),
    email: Yup.string(),
    matched: Yup.boolean(),
    profileImage: Yup.string().nullable(),
    investorProfileId: Yup.number()
  })),
  additionalEmails: Yup.array().of(Yup.string())
});

interface ConnectorReferralModalProps {
  open: boolean
  referralOptions: ConnectorReferralOption[]
  preselected?: ConnectorReferralOption
  onClose: () => void
  handleSubmit: (values: any) => void
}

const initialValues = {
  referralMessage: '',
  selectedInvestors: [],
  additionalEmails: []
};

const ConnectorReferralModal: React.FC<ConnectorReferralModalProps> = ({
  open,
  referralOptions,
  preselected = undefined,
  onClose,
  handleSubmit
}) => {
  const formik = useFormik({
    initialValues,
    validationSchema: preselected ? preselectValidationSchema : validationSchema,
    onSubmit: handleSubmit,
    // validateOnMount: true
    validateOnBlur: false,
    validateOnChange: true
  });

  useEffect(() => {
    if (open) {
      formik.resetForm();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
    >
      <Form formik={formik}>
        <DialogTitle>
          Make referral
        </DialogTitle>
        <DialogContent>
          {
            preselected !== undefined ? <StyledText variant='h4' style={{ marginTop: '0px' }}>{`To: ${preselected.contactName}`}</StyledText>
              : (
                <ContactSelect
                  id='investorEmailList'
                  label='To'
                  onBlur={formik.handleBlur}
                  value={formik.values.selectedInvestors}
                  menuItems={referralOptions}
                  onChange={(_event: any, value: ConnectorReferralOption[], reason: any) => {
                    if (reason === 'select-option' || reason === 'remove-option' || reason === 'clear') {
                      formik.setFieldValue('selectedInvestors', value);
                    }
                  }}
                />
              )
          }
          <TextInput
            id='referralMessage'
            label='Message to Investor'
            fullWidth
            type='text'
            placeholder='I want to share this referral with you because...'
            multiline
            rows={7}
          />
        </DialogContent>
        <DialogActions>
          <Button type='button' variant='text' onClick={onClose}>Cancel</Button>
          <Button type='submit' variant='contained' disabled={!formik.isValid || !formik.values.referralMessage}>Send</Button>
        </DialogActions>
      </Form>
    </Dialog>
  );
};

export default ConnectorReferralModal;
